import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import client from "../lib/api";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useAuth } from "../context/AuthContext";
import { Crown, Loader2, CheckCircle2, XCircle } from "lucide-react";

const PremiumSuccess = () => {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [state, setState] = useState({ status: "checking", message: "A confirmar pagamento..." });
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) { setState({ status: "error", message: "Sessão de pagamento inválida." }); return; }
    let cancelled = false;

    const poll = async () => {
      if (cancelled) return;
      try {
        const res = await client.get(`/payments/status/${sessionId}`);
        if (res.data.payment_status === "paid") {
          await refresh();
          setState({ status: "ok", message: "Pagamento concluído. Bem-vindo ao Premium." });
          return;
        }
        if (res.data.status === "expired") {
          setState({ status: "error", message: "Sessão expirada." });
          return;
        }
        attempts.current += 1;
        if (attempts.current >= 8) {
          setState({ status: "error", message: "Não foi possível confirmar o pagamento. Verifica o teu email." });
          return;
        }
        setTimeout(poll, 2000);
      } catch {
        attempts.current += 1;
        if (attempts.current >= 8) {
          setState({ status: "error", message: "Erro ao verificar o pagamento." });
          return;
        }
        setTimeout(poll, 2000);
      }
    };
    poll();
    return () => { cancelled = true; };
    // eslint-disable-next-line
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#0C0E12]" data-testid="premium-success-page">
      <Navbar />
      <main className="max-w-xl mx-auto px-6 py-20 text-center">
        <div className="bg-[#161920] border border-white/5 rounded-2xl p-12">
          {state.status === "checking" && (
            <>
              <Loader2 className="w-10 h-10 text-[#C5A880] mx-auto animate-spin" />
              <h1 className="font-display text-3xl mt-6">A processar...</h1>
              <p className="text-[#A29F9B] mt-2">{state.message}</p>
            </>
          )}
          {state.status === "ok" && (
            <>
              <Crown className="w-12 h-12 text-[#C5A880] mx-auto" />
              <h1 className="font-display text-4xl mt-6" data-testid="success-title">Premium Activo</h1>
              <p className="text-[#DCD7D2] mt-3">{state.message}</p>
              <div className="mt-10 flex flex-col gap-3">
                <Link to="/discover" className="btn-primary" data-testid="success-go-discover">Descobrir ligações</Link>
                <Link to="/admiradores" className="btn-secondary" data-testid="success-go-admirers">Ver quem te deu like</Link>
              </div>
            </>
          )}
          {state.status === "error" && (
            <>
              <XCircle className="w-12 h-12 text-[#7A2021] mx-auto" />
              <h1 className="font-display text-3xl mt-6">Algo correu mal</h1>
              <p className="text-[#A29F9B] mt-2">{state.message}</p>
              <Link to="/premium" className="btn-secondary inline-block mt-6">Voltar</Link>
            </>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PremiumSuccess;
